import * as React from 'react';

import { PaginationProvider, SelectedRowsProvider } from 'common/contexts';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import EventProcedureStepLibrary from './EventProcedureStepLibrary';

type Props = {
  selectedSteps: EventProcedureStepAPIType[];
  onClose: () => void;
  onAdd: (steps: EventProcedureStepAPIType[]) => void;
};

function EventProcedureStepLibraryForm({ selectedSteps, onClose, onAdd }: Props) {
  return (
    <SelectedRowsProvider>
      <PaginationProvider>
        <EventProcedureStepLibrary steps={selectedSteps} onClose={onClose} onAdd={onAdd} />
      </PaginationProvider>
    </SelectedRowsProvider>
  );
}

export default EventProcedureStepLibraryForm;
